var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 36,
    viewBox: "0 0 45 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.640625 35.0457V0.306641H44.0644V35.0457H0.640625ZM22.3525 19.8473L39.722 8.9914V4.64902L22.3525 15.505L4.983 4.64902V8.9914L22.3525 19.8473Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.640625 35.0457V0.306641H44.0644V35.0457H0.640625ZM22.3525 19.8473L39.722 8.9914V4.64902L22.3525 15.505L4.983 4.64902V8.9914L22.3525 19.8473Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.640625 35.0457V0.306641H44.0644V35.0457H0.640625ZM22.3525 19.8473L39.722 8.9914V4.64902L22.3525 15.505L4.983 4.64902V8.9914L22.3525 19.8473Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.640625 35.0457V0.306641H44.0644V35.0457H0.640625ZM22.3525 19.8473L39.722 8.9914V4.64902L22.3525 15.505L4.983 4.64902V8.9914L22.3525 19.8473Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.05194ad635cf3b9b58635ded4a564b03.svg";
export { ForwardRef as ReactComponent };